/*! @pentacode/ui v0.1.0 */
import { fieldOf as e } from "./table.util.js";
// src/elements/table/table-resize.ts
var t = class {
	constructor(e) {
		this.widths = /* @__PURE__ */ new Map(), this._resizeState = null, this.host = e, e.addController(this);
	}
	hostConnected() {}
	hostDisconnected() {}
	getWidth(t) {
		return this.widths.get(e(t)) ?? t.width ?? void 0;
	}
	setWidth(e, t) {
		this.widths = new Map(this.widths).set(e, t), this.host.requestUpdate();
	}
	handleResizeStart(t, n) {
		if (!t.isPrimary) return;
		t.preventDefault(), t.stopPropagation();
		let r = e(n), i = t.currentTarget.parentElement.getBoundingClientRect().width;
		this._resizeState = {
			field: r,
			startX: t.clientX,
			startWidth: i
		};
		let a = t.currentTarget;
		a.setPointerCapture(t.pointerId), document.body.style.cursor = "col-resize";
		let o = (e) => {
			if (!this._resizeState) return;
			let t = e.clientX - this._resizeState.startX, r = n.minWidth ?? 40, i = n.maxWidth ?? Infinity, a = Math.round(Math.min(i, Math.max(r, this._resizeState.startWidth + t)));
			this.widths = new Map(this.widths).set(this._resizeState.field, a), this.host.requestUpdate();
		}, s = () => {
			this._resizeState = null, document.body.style.cursor = "", a.removeEventListener("pointermove", o), a.removeEventListener("pointerup", s), a.removeEventListener("pointercancel", s);
		};
		a.addEventListener("pointermove", o), a.addEventListener("pointerup", s), a.addEventListener("pointercancel", s);
	}
};
export { t as ResizeController };

//# sourceMappingURL=table-resize.js.map